import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class BadgeDetailModal extends Component {
    
    componentDidMount() {
        document.body.addEventListener('click', this.props.toggleApply);
    }
    componentWillUnmount() {
        document.body.removeEventListener('click', this.props.toggleApply);
    }

    render() {
        return (
            <div className="model-container badge-details model-center model-backdrop-show">
                <span onClick={this.props.toggleApply} className="close "><img src="/images/close.svg" alt="close"/></span>
				<div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-content pt-3">
                        <img src={this.props.item.image} alt={this.props.item.name}></img>
					    <h2 className="model-title" id="model-title">{this.props.item.name}</h2>	
						<p id="model-content" className=" text-center description" >{this.props.item.description}</p>
                    </div>
                </div>
            </div>
        );
    }
}
BadgeDetailModal.contextType = AppContext;
export default BadgeDetailModal;



// WEBPACK FOOTER //
// ./src/components/writer/writerBadges/BadgeDetailModal.js